import Rest from '../Rest'

export default class PrivacyFormHandlingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/privacy-form'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  updateHandling(id: Number, fields: any) {
    return this.post(`${id}/handling`, fields).then(data => {
      return data
    })
  }

  deleteAttachment(id: Number, handlingId: Number, mediaId: Number) {
    return this.delete(`${id}/handling/${handlingId}/attachment/${mediaId}`)
  }

  listHandlingHistory(id: Number) {
    return this.get(`${id}/handling/history`).then(data => {
      return data
    })
  }
}
